module.exports = __webpack_public_path__ + "static/media/silver_dollar.3bf46c93.png";